module.exports = __webpack_public_path__ + "static/media/background.b7e4501e.jpg";